// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__D0cbA","colMin":"styles_colMin__3yQ1I"};